import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=4ab2fa6a&scoped=true&"
import script from "./DetailHeader.vue?vue&type=script&lang=ts&"
export * from "./DetailHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab2fa6a",
  null
  
)

export default component.exports